import React, { useState } from 'react'
import styled from 'styled-components';
import {useSelector } from "react-redux"

const About = () => {
    const reduxProfile = useSelector((store)=> store.port.profile)
    const text = reduxProfile[0]?.about ? reduxProfile[0]?.about : "";

    const ReadMore = () => {
        // const text = children;
        const [isReadMore, setIsReadMore] = useState(true);
        const toggleReadMore = () => {
          setIsReadMore(!isReadMore);
        };
        return (
          <p className="text">
            {isReadMore ? text.slice(0, 260) : text}
            <span onClick={toggleReadMore} className="read-or-hide">
              {isReadMore ? "...read more" : " show less"}
            </span>
          </p>
        );
      };
        

  return (
    <Wrapper>
        {
            reduxProfile !== "" && 
            <ReadMore>
             </ReadMore>
        }
      
        </Wrapper>
  )
}

const Wrapper = styled.section`
.container{
  position: absolute;
  top: 10%;
  left: 23%;
  width: 50%;
}
  
.text{
  display: inline;
  width: 100%;
  font-size: small;
}
  
.read-or-hide{
    color: #2B86C5;
  cursor: pointer;
}
`

export default About